export default "__VITE_ASSET__c2c05721__"